import { filter } from "lodash";

const initialState = {
  unsavedChanges: false,
  savedProductVariantCombinations: [],
  defaultSelectProducts: [],
  savingImportProducts: false,
  completedSavingImportProducts: false,
  removedCombinations: [],
  originalVariants: [],
  variants: [],
  groupedCombinations: [],
  productVariantCombinations: []
};

const productsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_UNSAVED_CHANGES':
      return {
        ...state,
        unsavedChanges: action.data
      }
    case 'GET_SELECT_PRODUCTS':
      return {
        ...state,
        defaultSelectProducts: action.data
      };
    case 'START_SAVING_IMPORT_PRODUCTS_REQUEST':
      return {
        ...state,
        savingImportProducts: true
      };
    case 'END_SAVING_IMPORT_PRODUCTS_REQUEST':
      return {
        ...state,
        savingImportProducts: false
      };
    case 'COMPLETED_SAIVING_IMPORT_PRODUCTS_REQUEST': {
      return {
        ...state,
        completedSavingImportProducts: action.completed.status
      };
    }
    case 'SET_REMOVED_COMBINATIOS': {
      return {
        ...state,
        removedCombinations: action.data
      };
    }
    case 'SET_ORIGINAL_VARIANTS':
      return {
        ...state,
        originalVariants: action.data
      }
    case 'SET_PRODUCT_VARIANTS':
      return {
        ...state,
        variants: action.data
      }
    case 'SET_SAVED_PRODUCT_VARIANT_COMBINATIONS':
      return {
        ...state,
        savedProductVariantCombinations: action.data
      }
    case 'ADD_SAVED_PRODUCT_VARIANT_COMBINATIONS': {
      const newCombination = [...state.savedProductVariantCombinations];
      newCombination.push(action.data);

      return {
        ...state,
        savedProductVariantCombinations: newCombination
      }
    }
    case 'REMOVE_SAVED_PRODUCT_VARIANT_COMBINATIONS': {
      return {
        ...state,
        savedProductVariantCombinations: filter(state.savedProductVariantCombinations, (comb) => (comb.web_id != action.data.web_id))
      }
    }
    case 'REMOVE_COMBINATION': {
      const newRemovedCombinations = [...state.removedCombinations];
      newRemovedCombinations.push(action.data);

      return {
        ...state,
        productVariantCombinations: filter(state.productVariantCombinations, (comb) => (comb.web_id != action.data.web_id)),
        removedCombinations: newRemovedCombinations
      }
    }
    case 'SET_PRODUCT_GROUPED_COMBINATIONS':
      return {
        ...state,
        groupedCombinations: action.data
      }
    case 'SET_PRODUCT_VARIANT_COMBINATIONS':
      return {
        ...state,
        productVariantCombinations: action.data
      }
    case 'ADD_REMOVED_COMBINATION': {
      const newCombination = [...state.removedCombinations];
      newCombination.push(action.data);

      return {
        ...state,
        removedCombinations: newCombination
      }
    }
    default:
      return state;
  }
};

export default productsReducer;